<template>
  <div class="panel">
    <h2 class="flex-row gap-sm m-2xs-b">
      <div class="dot">4</div>
      <div>Checkout</div>
    </h2>

    <template v-if="join.kit && join.info.accountInfoComplete">
      <div v-if="join.totals">
        <div class="pa-h3 m-1xl-t m-sm-b">Payment</div>
        <JoinCardForm>
          <span />
        </JoinCardForm>
      </div>
      <div v-else class="m-xl-t">
        <CartItems
          v-if="cart.items.length > 0"
          :showWishlist="false"
          :showPromoItems="false"
        />
        <div v-else class="flex-row flex-center flex-align-center m-sm p-sm">
          <em>No extra items</em>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useCartStore } from "@/stores/cart";
import { useJoinStore } from "@/stores/join";
import { useShopStore } from "@/stores/shop";
import CartItems from "../shop/CartItems.vue";
import JoinCardForm from "./JoinCardForm.vue";

const join = useJoinStore();
const cart = useCartStore();
const shop = useShopStore();
</script>

<style scoped>
:deep(.header-item),
:deep(.header-price),
:deep(.header-total),
:deep(.header-quantity),
:deep(.empty-header) {
  display: none;
}
</style>
